module.exports = __webpack_public_path__ + "static/media/darkness-win.141ad3d1.png";